module.exports = __webpack_public_path__ + "static/media/truck.73c6ff9b.png";